import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { getOrder } from '@services/order.service'
import Spinner from '@components/UI/Spinner'
import './OrderSuccessPage.scss'

export default function OrderSuccessPage() {
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('id')
  const orderNumber = searchParams.get('number')
  const [order, setOrder] = useState(null)
  const [loading, setLoading] = useState(!!orderId)

  useEffect(() => {
    if (!orderId) return
    let cancelled = false
    getOrder(orderId)
      .then((res) => { if (!cancelled) setOrder(res?.data ?? null) })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [orderId])

  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h1 className="success-title">Comandă plasată cu succes!</h1>
        <p className="success-number">
          Comanda #{orderNumber || order?.order_number || '—'}
        </p>
        <p className="success-text">
          Mulțumim pentru comandă! Vei primi un email de confirmare în curând.
        </p>

        {loading ? (
          <Spinner />
        ) : order ? (
          <div className="success-details">
            <div className="success-detail-row">
              <span>Total</span>
              <span>{order.total_amount} lei</span>
            </div>
            <div className="success-detail-row">
              <span>Metodă de plată</span>
              <span>
                {order.payment_method === 'card' && 'Card bancar'}
                {order.payment_method === 'cash_on_delivery' && 'Ramburs'}
                {order.payment_method === 'bank_transfer' && 'Transfer bancar'}
                {!order.payment_method && '—'}
              </span>
            </div>
            <div className="success-detail-row">
              <span>Status plată</span>
              <span className={`success-status ${order.payment_status}`}>
                {order.payment_status === 'paid' && 'Plătită'}
                {order.payment_status === 'pending' && 'În așteptare'}
                {order.payment_status === 'failed' && 'Eșuată'}
                {order.payment_status === 'refunded' && 'Rambursată'}
              </span>
            </div>
            <div className="success-detail-row">
              <span>Livrare</span>
              <span>{order.shipping_city}, {order.shipping_county || ''} {order.shipping_postal_code}</span>
            </div>
          </div>
        ) : null}

        <div className="success-actions">
          <Link to="/shop" className="btn-primary">Continuă cumpărăturile</Link>
          <Link to="/" className="success-home-link">Înapoi la pagina principală</Link>
        </div>
      </div>
    </div>
  )
}
